export default __webpack_public_path__ + "static/media/floor8map.1de92304.svg";